// frontend/src/pages/public/Disclaimer/DisclaimerContent.ts

export const disclaimerPage = {
  eyebrow: "Legal",
  title: "Disclaimer",
  subtitle:
    "AcceptingMD is a care discovery and connection platform. Please read this disclaimer carefully before using the site.",
  sections: [
    {
      title: "No Medical Advice",
      body: [
        "AcceptingMD does not provide medical advice, diagnosis, or treatment.",
        "Content on this platform is not a substitute for professional medical advice. Always seek the advice of a qualified health professional with any questions regarding a medical condition.",
        "Never disregard professional medical advice or delay seeking care because of information found on this platform.",
      ],
    },
    {
      title: "No Provider–Patient Relationship",
      body: [
        "Using AcceptingMD does not create a provider–patient relationship.",
        "Clinics and providers listed on the platform operate independently. Submitting a request does not guarantee acceptance by a clinic.",
        "Clinics determine their own intake criteria, availability, and care processes. Any relationship established is solely between the patient and the provider.",
      ],
    },
    {
      title: "Accuracy of Information",
      body: [
        "While we strive to keep information up to date, provider profiles, services, hours, and availability are managed by providers themselves and may change without notice.",
        "AcceptingMD does not guarantee the completeness, accuracy, or timeliness of listings or content.",
      ],
    },
    {
      title: "Third-Party Services and Links",
      body: [
        "AcceptingMD may include links to third-party websites or services.",
        "We do not control or endorse third-party content and are not responsible for the availability, accuracy, or privacy practices of external sites.",
        "Use of third-party services is at your own discretion.",
      ],
    },
    {
      title: "Limitation of Liability",
      body: [
        "To the fullest extent permitted by law, AcceptingMD is not liable for any loss, injury, or damages arising from use of the platform.",
        "This includes direct, indirect, incidental, or consequential damages.",
        "Use of the platform is at your own risk.",
      ],
    },
    {
      title: "Platform Availability",
      body: [
        "We do not guarantee uninterrupted or error-free access to the platform.",
        "Features may change, be suspended, or discontinued, and maintenance or technical issues may affect availability.",
      ],
    },
    {
      title: "Jurisdiction",
      body: [
        "This platform is intended for use in Canada.",
        "Any disputes arising from use of AcceptingMD are governed by applicable Canadian federal and provincial laws.",
      ],
    },
    {
      title: "Acceptance of Disclaimer",
      body: [
        "By using this platform, you acknowledge that you have read, understood, and agree to this Disclaimer.",
      ],
    },
  ],
  ctas: {
    title: "Continue using AcceptingMD",
    subtitle:
      "You can return to care search or learn how the platform works at any time.",
    primary: { label: "Find a Family Doctor", to: "/public/find-family-doctor" },
    secondary: { label: "How It Works", to: "/public/how-it-works" },
  },
};
